// engine
import { ArController, userDispatcher } from '@aceroll/core';

// library
import { slotDispatcher } from '@aceroll/core/library';

// hacksaw
import { responseService, uiService } from '@aceroll/platform-hacksaw';

// platform
import { platform } from '../../platform';
import dataActionType from '../../platform/constants/data-action-type';

// services
import { winAnimationService } from '../../services/win-animation-service';

export class EvFsRespin extends ArController {
	async onStart() {
		const serverEvent = responseService.getEvent();
		// console.log('serverEvent', serverEvent);
		const { totalWin, data } = serverEvent
		const { reelSet, symbols, actions } = data;
		platform.setFeatureRoundStarted({ uistate: "freespins", gameMode: reelSet });

		const { slotMachine, healthBar } = this.context.currentLayout;

		// userDispatcher.setTempMode(SPECIAL_SPIN_MODE);
		await slotMachine.spin();

		uiService.onShowResult(userDispatcher.slamStop);
		slotDispatcher.updateSymbols(symbols, reelSet, []);
		await slotMachine.stop();
		uiService.offShowResult(userDispatcher.slamStop);

		await winAnimationService.playEvent(serverEvent);

		const isAnyMultiplier = actions.some((action) => {
			return action.type === dataActionType.ADD ||
				action.type === dataActionType.MULTIPLY ||
				action.type === dataActionType.EPIC_ADD ||
				action.type === dataActionType.EPIC_MULTIPLIY
		});

		if (isAnyMultiplier) {
			await healthBar.reset();
		} else {
			await healthBar.take(1); // take one health point each spin
		}

		// update health points in the ui
		platform.setFeatureCounter(healthBar.getHealth());

		platform.setFeatureTotalWin(totalWin);
		platform.setFeatureRoundCompleted(serverEvent.win);
		responseService.completeEvent();

		// userDispatcher.clearTempMode();
		this.stop();
	}

}
